export default "__VITE_ASSET__3989b7c3__"